import React from 'react'

function ButtonSkeleton({ count = 3 }) {
    return (
        <div className="flex flex-row gap-[15px] animate-pulse">
            {Array.from({ length: count }).map((_, idx) => {
                let width = 120
                if (idx === 0) width = 142
                else if (idx === 1) width = 123
                else if (idx === 2) width = 154
                return <div key={idx} className="rounded-[10px] px-[30px] h-[60px] min-w-[123px] max-w-[154px] w-full bg-aquaPulse animate-pulse opacity-50" style={{ width }} />
            })}
        </div>
    )
}

export default ButtonSkeleton
